import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import FMFile from 'file-manager-components/types/FMFile';

const baseHubSpotUrl = getFullUrl('api');

export const getSignedSrc = (fileManagerId: number) => {
  const portalId = PortalIdParser.get();
  return `${baseHubSpotUrl}/filemanager/api/v2/files/${fileManagerId}/signed-url-redirect?portalId=${portalId}`;
};

export const isPrivateFile = (fileObject: FMFile) => {
  return fileObject.meta?.allows_anonymous_access === false;
};
